"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeightEventQueueBodySchema = exports.UpdateAnimlaQueueBodySchema = exports.NewAnimalQueueBodySchema = void 0;
const zod_1 = require("zod");
const activity_1 = require("../lib/activity");
const token_1 = require("../misc/token");
const asset_1 = require("../misc/asset");
exports.NewAnimalQueueBodySchema = zod_1.z.object({
    auth: zod_1.z.string(),
    agliveToken: zod_1.z.literal(true),
    scope: zod_1.z.literal("digirodeo"),
    externalIds: zod_1.z.tuple([
        token_1.ExternalIdsSchema.pick({ agliveToken: true, timestamp: true }).required(),
        token_1.ExternalIdsSchema.pick({ uhf: true, timestamp: true }).required(),
        token_1.ExternalIdsSchema.pick({ digirodeo_id: true, timestamp: true }).required(),
    ]),
    businessId: zod_1.z.string(),
    type: zod_1.z.literal(token_1.tokenTypesSchema.enum.asset),
    details: asset_1.AssetDetailSchema.pick({
        weight: true,
        date_of_weight: true,
        date_of_birth: true,
        pic_id: true,
        breed: true,
        lot_name: true,
        sex: true,
    }).required().merge(zod_1.z.object({
        externalIds: token_1.ExternalIdsSchema.pick({ uhf: true }).required(),
        category: zod_1.z.string(),
    })),
    createdAt: zod_1.z.string()
});
exports.UpdateAnimlaQueueBodySchema = zod_1.z.object({
    auth: zod_1.z.string(),
    agliveToken: zod_1.z.literal(true),
    scope: zod_1.z.literal("digirodeo"),
    externalIds: token_1.ExternalIdsSchema.pick({ uhf: true, digirodeo_id: true }).required(),
    businessId: zod_1.z.string(),
    type: zod_1.z.literal(activity_1.ActivityTypeSchema.enum.UP_details),
    details: asset_1.AssetDetailSchema.pick({ lot_name: true }).required(),
    createdAt: zod_1.z.string()
});
exports.WeightEventQueueBodySchema = zod_1.z.object({
    auth: zod_1.z.string(),
    scope: zod_1.z.literal("digirodeo"),
    externalIds: token_1.ExternalIdsSchema.pick({ digirodeo_id: true }).required(),
    type: zod_1.z.literal(activity_1.ActivityTypeSchema.enum.updateWeight),
    details: asset_1.AssetDetailSchema.pick({
        weight: true,
        date_of_weight: true
    }).required(),
    createdAt: zod_1.z.string()
});
